import { render, staticRenderFns } from "./AddDiscount.vue?vue&type=template&id=e0fbcdfe&scoped=true&"
import script from "./AddDiscount.vue?vue&type=script&lang=js&"
export * from "./AddDiscount.vue?vue&type=script&lang=js&"
import style0 from "./AddDiscount.vue?vue&type=style&index=0&id=e0fbcdfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0fbcdfe",
  null
  
)

export default component.exports